<template>
  <div>  
    <!-- Modal Confirmation -->
    <div 
      class="modal fade" 
      id="modalEditLostStatusConfirm" 
      tabindex="-1" 
      role="dialog" 
      aria-labelledby="modalEditLostStatusConfirmLabel" 
      aria-hidden="true"
      data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content status-modal">
          <div class="modal-body text-center p-4">
            <!-- Icon -->
            <div class="modal-icon mb-3">
              <!-- <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="40" fill="#E3F2FD"/>
                <path d="M40 20C28.96 20 20 28.96 20 40C20 51.04 28.96 60 40 60C51.04 60 60 51.04 60 40C60 28.96 51.04 20 40 20ZM44 50H36V42H44V50ZM44 38H36V30H44V38Z" fill="#2196F3"/>
              </svg> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                <rect x="3" y="3" width="74" height="74" rx="37" stroke="#1C68D9" stroke-opacity="0.2" stroke-width="6"/>
                <g clip-path="url(#clip0_24803_17098)">
                <path d="M27.5 38.3333H30.8333C34.9667 38.3333 38.3333 34.9667 38.3333 30.8333V27.5C38.3333 23.3667 34.9667 20 30.8333 20H27.5C23.3667 20 20 23.3667 20 27.5V30.8333C20 34.9667 23.3667 38.3333 27.5 38.3333ZM25 27.5C25 26.1167 26.1167 25 27.5 25H30.8333C32.2167 25 33.3333 26.1167 33.3333 27.5V30.8333C33.3333 32.2167 32.2167 33.3333 30.8333 33.3333H27.5C26.1167 33.3333 25 32.2167 25 30.8333V27.5ZM52.5 41.6667H49.1667C45.0333 41.6667 41.6667 45.0333 41.6667 49.1667V52.5C41.6667 56.6333 45.0333 60 49.1667 60H52.5C56.6333 60 60 56.6333 60 52.5V49.1667C60 45.0333 56.6333 41.6667 52.5 41.6667ZM55 52.5C55 53.8833 53.8833 55 52.5 55H49.1667C47.7833 55 46.6667 53.8833 46.6667 52.5V49.1667C46.6667 47.7833 47.7833 46.6667 49.1667 46.6667H52.5C53.8833 46.6667 55 47.7833 55 49.1667V52.5ZM37.85 51.3167C38.5 51.9667 38.5 53.0167 37.85 53.6667L32.85 58.9333C31.8 59.9833 30 59.2333 30 57.75V54.9833H27.5C23.3667 54.9833 20 51.6167 20 47.4833V44.15C20 42.7667 21.1167 41.65 22.5 41.65C23.8833 41.65 25 42.7667 25 44.15V47.4833C25 48.8667 26.1167 49.9833 27.5 49.9833H30V47.2167C30 45.7333 31.8 44.9833 32.85 46.0333L37.85 51.3V51.3167ZM60 32.5V35.8333C60 37.2167 58.8833 38.3333 57.5 38.3333C56.1167 38.3333 55 37.2167 55 35.8333V32.5C55 31.1167 53.8833 30 52.5 30H50V32.7667C50 34.25 48.2 35 47.15 33.95L42.15 28.6833C41.5 28.0333 41.5 26.9833 42.15 26.3333L47.15 21.0667C48.2 20.0167 50 20.7667 50 22.25V25.0167H52.5C56.6333 25.0167 60 28.3833 60 32.5167V32.5Z" fill="#1C68D9"/>
                </g>
                <defs>
                <clipPath id="clip0_24803_17098">
                <rect width="40" height="40" fill="white" transform="translate(20 20)"/>
                </clipPath>
                </defs>
              </svg>
            </div>
            
            <!-- Title -->
            <h5 class="modal-title mb-3" id="changeStatusModalLabel">Change Status</h5>
            
            <!-- Message -->
            <p class="modal-message mb-4">
              Are you sure you want to set to <strong>{{ capitalizeStatus(newStatus) }}?</strong>
            </p>
            
            <!-- Buttons -->
            <div class="modal-buttons d-flex justify-content-center gap-3">
              <button 
                type="button" 
                class="btn btn-back px-4 py-2" 
                @click="closeModal">
                Back
              </button>
              <button 
                type="button" 
                class="btn btn-confirm px-4 py-2" 
                @click="confirmStatusChange">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name : 'ModalEditLostStatusConfirm',
  props : {
    newStatus : String,
    updateStatus : Function
  },
  data() {
    return {
    }
  },
  
  methods: {
    // handleStatusUpdate() {
    //   $('#modalEditLostStatusConfirm').modal('show');
    // },
    
    confirmStatusChange() {
      // Panggil fungsi update status asli
      this.updateStatus();
    },
    
    closeModal() {
      $('#modalEditLostStatusConfirm').modal('hide');;
    },
    
    capitalizeStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1);
    },
  },
  
  beforeDestroy() {
    $('#changeStatusModal').modal('hide');
    $('.dropdown-toggle').dropdown('dispose');
  }
}
</script>

<style scoped>
/* Modal Custom Styling */
.status-modal {
  border-radius: 16px;
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.modal-icon {
  display: inline-block;
}

.modal-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
}

.modal-message {
  font-size: 16px;
  color: #5a6c7d;
  line-height: 1.5;
}

.modal-message strong {
  color: #2c3e50;
  font-weight: 600;
}

/* Button Styling */
.modal-buttons {
  gap: 12px;
}

.btn-back {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  font-weight: 500;
  border-radius: 8px;
  min-width: 100px;
  transition: all 0.2s ease;
}

.btn-back:hover {
  background-color: #e9ecef;
  border-color: #ced4da;
  transform: translateY(-1px);
}

.btn-confirm {
  background-color: #2196F3;
  border: none;
  color: white;
  font-weight: 500;
  border-radius: 8px;
  min-width: 100px;
  transition: all 0.2s ease;
}

.btn-confirm:hover {
  background-color: #1976D2;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
}

.btn-back:focus,
.btn-confirm:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.2);
}

/* Custom gap untuk flexbox (Bootstrap 4 tidak punya gap utility) */
.gap-3 > * + * {
  margin-left: 12px;
}

/* Modal backdrop custom */
.modal-backdrop.show {
  opacity: 0.6;
}
</style>


// WEBPACK FOOTER //
// src/components/Order/CustomComponent/ModalEditLostStatusConfirm.vue